import script from "./importExcel.vue?vue&type=script&setup=true&lang=js"
export * from "./importExcel.vue?vue&type=script&setup=true&lang=js"

import "./importExcel.vue?vue&type=style&index=0&id=4c1cf596&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/MODC/modc-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1cf596"]])

export default __exports__